export default "__VITE_ASSET__ConVQGAF__"